/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Remove_ButtonInputs */



/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Media_Tab_Remove_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_remove_button = /** @type {((inputs?: Media_Tab_Remove_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Remove_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("消除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("取り除く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निकालना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover")
	return /** @type {LocalizedString} */ ("Remove")
});